module.exports = __webpack_public_path__ + "img/logo_acceso.5ab0c6de.png";